import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
  let fadeUpElements = gsap.utils.toArray(".amdg-fade-up");

  let mobile = gsap.matchMedia();
  mobile.add("(min-width: 768px)", () => {
    fadeUpElements.forEach((el) => {
      fadeUpAnimation(el);
    });
  });

  function fadeUpAnimation(el) {
    gsap.fromTo(
      el,
      { autoAlpha: 0, y: 30 },
      {
        scrollTrigger: {
          trigger: el,
          start: "top 95%",
        },
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: "power1.inOut",
      }
    );
  }

  if ($("body").hasClass("page-safety")) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#gradient_circle",
        start: "top center",
      },
    });
    tl.set("#safety-circle, .safety-content-wrap", { visibility: "visible" })
      .set("#gradient_circle", {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
      })
      .set("#pointer_circles", {
        opacity: 0,
        rotation: -90,
        scale: 0.8,
        transformOrigin: "center center",
      })
      .set("#line_circles .line-two, #line_circles .line-one", {
        opacity: 0,
        scale: 0.5,
        transformOrigin: "center center",
      })
      .set("#line_circles .line-three", {
        opacity: 0,
      })
      .set(".safety-content-wrap", {
        opacity: 0,
        scale: 0.85,
        transformOrigin: "center center",
      })
      .set("#pointer_lines, #text", {
        opacity: 0,
      })
      .to(
        ".safety-content-wrap",
        {
          scale: 1,
          opacity: 1,
          duration: 1,
        },
        0
      )
      .to(
        "#gradient_circle",
        {
          scale: 1,
          opacity: 1,
          rotation: 360,
          duration: 1,
        },
        0
      )
      .to("#line_circles .line-three", {
        opacity: 1,
      })
      .to(
        "#pointer_circles, #line_circles .line-two, #line_circles .line-one",
        {
          scale: 1,
          rotation: 0,
          opacity: 1,
          duration: 1,
        }
      )
      .to(
        "#line_circles .line-two, #line_circles .line-one",
        {
          opacity: 1,
          duration: 1,
        },
        2
      )
      .to(
        "#pointer_lines, #text",
        {
          opacity: 1,
          duration: 1,
        },
        2.5
      );
  }

  if ($("body").hasClass("page-environmental")) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#line_circles",
        start: "top center",
      },
    });
    tl.set("#environmental-circle, .environmental-content-wrap", {
      visibility: "visible",
    })
      .set("#gradient_circle", {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
      })
      .set("#pointer_circles", {
        opacity: 0,
        rotation: -90,
        scale: 0.8,
        transformOrigin: "center center",
      })
      .set("#line_circles .line-two, #line_circles .line-one", {
        opacity: 0,
        scale: 0.5,
        transformOrigin: "center center",
      })
      .set("#line_circles .line-three", {
        opacity: 0,
      })
      .set(".environmental-content-wrap", {
        opacity: 0,
        scale: 0.85,
        transformOrigin: "center center",
      })
      .set("#pointer_lines, #text", {
        opacity: 0,
      })
      .to(
        ".environmental-content-wrap",
        {
          scale: 1,
          opacity: 1,
          duration: 1,
        },
        0
      )
      .to(
        "#gradient_circle",
        {
          scale: 1,
          opacity: 1,
          rotation: 360,
          duration: 1,
        },
        0
      )
      .to("#line_circles .line-three", {
        opacity: 1,
      })
      .to(
        "#pointer_circles, #line_circles .line-two, #line_circles .line-one",
        {
          scale: 1,
          rotation: 0,
          opacity: 1,
          duration: 1,
        }
      )
      .to(
        "#line_circles .line-two, #line_circles .line-one",
        {
          opacity: 1,
          duration: 1,
        },
        2
      )
      .to(
        "#pointer_lines, #text",
        {
          opacity: 1,
          duration: 1,
        },
        2.5
      );
  }

  if ($("body").hasClass("page-social")) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#line_circles",
        start: "top center",
      },
    });
    tl.set("#social-circle, .social-content-wrap", {
      visibility: "visible",
    })
      .set("#gradient_circle", {
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
      })
      .set("#pointer_circles", {
        opacity: 0,
        rotation: -90,
        scale: 0.8,
        transformOrigin: "center center",
      })
      .set("#line_circles .line-two, #line_circles .line-one", {
        opacity: 0,
        scale: 0.5,
        transformOrigin: "center center",
      })
      .set("#line_circles .line-three", {
        opacity: 0,
      })
      .set(".social-content-wrap", {
        opacity: 0,
        scale: 0.85,
        transformOrigin: "center center",
      })
      .set("#pointer_lines, #text", {
        opacity: 0,
      })
      .to(
        ".social-content-wrap",
        {
          scale: 1,
          opacity: 1,
          duration: 1,
        },
        0
      )
      .to(
        "#gradient_circle",
        {
          scale: 1,
          opacity: 1,
          rotation: 360,
          duration: 1,
        },
        0
      )
      .to("#line_circles .line-three", {
        opacity: 1,
      })
      .to(
        "#pointer_circles, #line_circles .line-two, #line_circles .line-one",
        {
          scale: 1,
          rotation: 0,
          opacity: 1,
          duration: 1,
        }
      )
      .to(
        "#line_circles .line-two, #line_circles .line-one",
        {
          opacity: 1,
          duration: 1,
        },
        2
      )
      .to(
        "#pointer_lines, #text",
        {
          opacity: 1,
          duration: 1,
        },
        2.5
      );
  }
});
